import { env } from "resume-builder-v2-common";
import { useFetchData } from "./use-fetch-data";
export var useResumeData = function useResumeData(id, mode, cacheKey) {
  var url = id ? "".concat(env.api, "/v1/resume/").concat(mode === "edit" ? "" : "view/").concat(encodeURIComponent(id)) : undefined;
  var fetchData = useFetchData(url, cacheKey);
  return fetchData;
};